module.exports = __webpack_public_path__ + "static/media/banner1.287d4f87.jpg";